import React from "react";

function IconBadFish() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="21"
      viewBox="0 0 24 21"
    >
      <path
        fill="#e44c00"
        stroke="#ff6614"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20.84 2.61a5.5 5.5 0 00-7.78 0L12 3.67l-1.06-1.06a5.501 5.501 0 00-7.78 7.78l1.06 1.06L12 19.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
      ></path>
    </svg>
  );
}
export default IconBadFish;
